import { ChangeDetectionStrategy, Component } from '@angular/core';
import { delay, map } from 'rxjs/operators';
import { ProgressBarService } from './progress-bar.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  isVisible$: Observable<boolean> = this.progressBar.isVisible$.pipe(
    delay(10),
    map(visible => visible),
  );

  constructor(private progressBar: ProgressBarService) {}
}
